import { AvailableTemplate, ExportDto } from '@ecosystem/export-api';

const roundRow = (row: any[], roundIndexes: number[]) => {
  for (const idx of roundIndexes) {
    const cell = row[idx];
    if (typeof cell.value === 'number') {
      const rounded = Math.round(cell.value);
      cell.value = rounded === 0 ? 0 : rounded;
    }
  }
};

export const roundExportValues = (exportData: ExportDto) => {
  if (exportData.template !== AvailableTemplate.Excel) {
    return;
  }
  const keywords = ['Selling Shops', 'Selling Shops change'];

  for (const sheet of exportData.worksheets) {
    const { dataColumns, dataRows, summaryRows } = sheet.data;

    // figure out which column‐indexes to round
    const roundIndexes = dataColumns
      .map((col, idx) => (keywords.some(kw => col.header.includes(kw)) ? idx : -1))
      .filter(idx => idx >= 0);

    dataRows.forEach(row => roundRow(row, roundIndexes));
    summaryRows?.forEach(row => roundRow(row, roundIndexes));
  }
};
